<div class="orders-list">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border py-3 mb-4">
    <h1>Billing Notes</h1>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
    </div>
  </header>

  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="orderNotesGridListing"
    [(selection)]="selectedOrderNotesGridListing"
    styleClass="p-datatable-customers no-overfollow ordersLineItems no-wrap table-hover-bg"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [paginator]="false"
    [filterDelay]="0"
    dataKey="id"
    editMode="row"
    selectionMode="multiple">
    <ng-template pTemplate="header">
      <tr>
        <th class="col-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="number">Type</th>
        <th class="status">Purchase Order</th>
        <th class="name">Description</th>
        <th class="name">Note</th>
        <th class="name">Created By</th>
        <th class="name">Created date</th>
        <th class="name">Modified By</th>
        <th class="name">Modified date</th>
      </tr>
      <tr>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="type"
              id="type"
              style="max-width: 200px"
              (input)="dt.filter($any($event.target).value, 'type', 'contains')"
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="purchaseOrderId"
              id="purchaseOrderId"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'purchaseOrderId',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="description"
              id="description"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'description', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="note"
              id="note"
              style="max-width: 200px"
              (input)="dt.filter($any($event.target).value, 'note', 'contains')"
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="createdBy"
              id="createdBy"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'createdBy', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-orderNotesGridListing
      let-editing="editing"
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pEditableRow]="orderNotesGridListing"
        [pSelectableRow]="orderNotesGridListing"
        [ngClass]="{ 'line-gray': !orderNotesGridListing?.isActive }"
        [pSelectableRowDisabled]="!orderNotesGridListing?.isActive">
        <td class="col-center">
          <p-tableCheckbox
            [pSelectableRow]="orderNotesGridListing"
            [value]="orderNotesGridListing"></p-tableCheckbox>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-select
                class="p-0"
                id="currency"
                [(ngModel)]="orderNotesGridListing.type"
                [filter]="true"
                [showClear]="true"
                [options]="typeList"
                optionLabel="name"
                optionValue="name">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.type }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            {{ purchaseOrderNumber }}
            <ng-template pTemplate="input">
              <p-select
                class="p-0"
                id="currency"
                [(ngModel)]="orderNotesGridListing.purchaseOrderId"
                [filter]="true"
                [showClear]="true"
                [options]="purchaseOrderNumber">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.purchaseOrderId }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderNotesGridListing.description"
                required />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.description }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderNotesGridListing.note"
                required />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.note }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>{{ orderNotesGridListing.createdBy }}</td>
        <td>
          <span *ngIf="orderNotesGridListing?.createdDate | hidedynamicsdate">
            {{ orderNotesGridListing.createdDate | date: "MM-dd-yyyy" }}
          </span>
        </td>
        <td>{{ orderNotesGridListing.lastModifiedBy }}</td>
        <td>
          {{ orderNotesGridListing.lastModifiedDate | date: "MM-dd-yyyy" }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
